import type { AudioItemSummary } from './legacy-client-types';

// Audio statuses considered "playable" by the UI — used to filter list views
// (continue-listening, files-page) and gate detail-loading. Moved out of
// query-options-service.ts so the constant survives Phase 5's deletion of
// the legacy openapi-fetch surface.
export const readyAudioStatuses: ReadonlyArray<
  AudioItemSummary['conversion_status']
> = ['complete', 'completedExtraction'];

// Set form for `.has(status)` membership checks in list `select` filters
// (library vs processing queue). Derived from `readyAudioStatuses` so the
// playable set has one source — don't re-declare a local `READY_STATUS_SET`.
export const readyAudioStatusSet: ReadonlySet<string> = new Set(
  readyAudioStatuses,
);
